import { DateObject, dateObjectTimestampSeconds, formatDateObject } from 'tabs/topQuestions/utils/DateUtils'
import React from 'react'
import AnimationIcon from '@mui/icons-material/Animation'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'

import './TopQuestionsHistoricalDataNotFound.scss'
import Card from '@mui/material/Card'
import { CardContent } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { sendStartClusteringChartData } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusApi'
import { selectActiveBotId } from 'tabs/home/reducers/selectors'

type TopQuestionsHistoricalDataNotFoundProps = {
  minDate: DateObject
  maxDate: DateObject
  onStartTraining: () => void
}

export const TopQuestionsHistoricalDataNotFound: React.FC<TopQuestionsHistoricalDataNotFoundProps> = ({ minDate, maxDate, onStartTraining }) => {

  const dispatch = useDispatch()
  const botId = useSelector(selectActiveBotId)

  const submitStartTraining = async () => {
    const mingTimestamp = dateObjectTimestampSeconds(minDate)
    const maxTimestamp = dateObjectTimestampSeconds(maxDate)
    dispatch(sendStartClusteringChartData(botId, mingTimestamp, maxTimestamp))
    onStartTraining()
  }

  return <Card classes={{ root: 'TopQuestionsHistoricalDataNotFound-card' }}>
    <CardContent>
      <h5>Top Question data is not trained for the period:</h5>
      <small>{formatDateObject(minDate)} - {formatDateObject(maxDate)}</small>
      <Divider />
      <div className={'TopQuestionsHistoricalDataNotFound-action-wrapper'}>
        <Button onClick={submitStartTraining} startIcon={<AnimationIcon />}>
          Start clustering
        </Button>
      </div>
    </CardContent>
  </Card>

}
